import React from "react";
import { getCategoryColor } from "../lib/constants";

/**
 * Editorial SVG gin bottle silhouette.
 * Color tinted by category. No external bitmap, no hotlinks.
 */
export default function BottleSilhouette({ category = "classic", size = 200, glow = true, className = "" }) {
  const color = getCategoryColor(category);
  return (
    <svg
      viewBox="0 0 120 280"
      width={size}
      height={size * (280 / 120)}
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={`grad-${category}`} x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.85" />
          <stop offset="50%" stopColor={color} stopOpacity="0.55" />
          <stop offset="100%" stopColor={color} stopOpacity="0.25" />
        </linearGradient>
        {glow && (
          <radialGradient id={`glow-${category}`} cx="0.5" cy="0.4" r="0.6">
            <stop offset="0%" stopColor={color} stopOpacity="0.35" />
            <stop offset="60%" stopColor={color} stopOpacity="0.05" />
            <stop offset="100%" stopColor={color} stopOpacity="0" />
          </radialGradient>
        )}
        <linearGradient id="bottle-shine" x1="0" x2="1" y1="0" y2="0">
          <stop offset="0%" stopColor="rgba(255,255,255,0)" />
          <stop offset="50%" stopColor="rgba(255,255,255,0.18)" />
          <stop offset="100%" stopColor="rgba(255,255,255,0)" />
        </linearGradient>
      </defs>

      {glow && <ellipse cx="60" cy="170" rx="80" ry="120" fill={`url(#glow-${category})`} />}

      {/* Cap */}
      <rect x="49" y="8" width="22" height="22" fill="#2A2A2A" stroke={color} strokeOpacity="0.5" strokeWidth="0.8" />
      {/* Neck */}
      <path d="M52,30 L52,68 Q52,72 56,74 L64,74 Q68,72 68,68 L68,30 Z"
            fill="#1E2024" stroke={color} strokeOpacity="0.4" strokeWidth="0.8" />
      {/* Shoulder + body (square shoulder, premium spirits silhouette) */}
      <path d="M30,74 Q30,90 36,98 L36,250 Q36,266 52,266 L68,266 Q84,266 84,250 L84,98 Q90,90 90,74 Z"
            fill={`url(#grad-${category})`} stroke={color} strokeOpacity="0.9" strokeWidth="1.4" />
      {/* Vertical shine */}
      <rect x="50" y="100" width="6" height="140" fill="url(#bottle-shine)" />
      {/* Label band */}
      <rect x="38" y="146" width="44" height="58" fill="rgba(14,15,12,0.78)" stroke={color} strokeOpacity="0.6" strokeWidth="0.6" />
      <line x1="42" y1="158" x2="78" y2="158" stroke={color} strokeOpacity="0.5" strokeWidth="0.4" />
      <line x1="42" y1="194" x2="78" y2="194" stroke={color} strokeOpacity="0.5" strokeWidth="0.4" />
      <circle cx="60" cy="176" r="6" fill="none" stroke={color} strokeOpacity="0.7" strokeWidth="0.6" />
    </svg>
  );
}
